import { Counter, TabGroup, type TabGroupTab } from "@synthesis/shared-ui";

import { ADMIN_REFERENCE_TAB_COUNTS } from "./admin-console.constants";

const renderTabTitle = (label: string, count: number) => (
  <span className="inline-flex flex-nowrap items-center">
    <span>{label}</span>
    &nbsp;
    {count > 0 ? <Counter count={count} warningColor={false} /> : null}
  </span>
);

const REFERENCE_TABS: { key: string; title: string; count: number }[] = [
  { key: "document-types", title: "Типы документов", count: ADMIN_REFERENCE_TAB_COUNTS.documentTypes },
  { key: "roles", title: "Роли и пользователи", count: ADMIN_REFERENCE_TAB_COUNTS.roles },
  { key: "organizations", title: "Организации-заявители", count: ADMIN_REFERENCE_TAB_COUNTS.organizations },
  { key: "work-types", title: "Виды работ", count: ADMIN_REFERENCE_TAB_COUNTS.workTypes },
];

/**
 * Табы «Справочники». Контент реализован для «Типов документов» и «Видов работ»,
 * остальные разделы переключаются без контента (появятся отдельными задачами).
 */
export const ReferenceTabs = ({
  activeKey,
  onChange,
  workTypesCount,
}: {
  activeKey: string;
  onChange: (key: string) => void;
  /** Счётчик «Виды работ» из реального справочника; по умолчанию — константа макета. */
  workTypesCount?: number;
}) => {
  const tabs: TabGroupTab[] = REFERENCE_TABS.map((tab) => ({
    key: tab.key,
    value: tab.key,
    title: renderTabTitle(tab.title, tab.key === "work-types" ? (workTypesCount ?? tab.count) : tab.count),
  }));

  return <TabGroup className="w-full min-w-0" tabs={tabs} activeKey={activeKey} onChange={onChange} />;
};
